import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Segment, Header, Dropdown, Grid, Pagination} from 'semantic-ui-react';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import {produce} from 'immer';
import ApiActions from 'go/actions/api';
import {API_ORG_GET_ALL_SUBORGS_SUCCESS} from 'common/types';
import {
  ASSOCIATED_ENTITY_STATUSES,
  STATUS_INELIGIBLE,
  STATUS_SUBAWARD_ACCEPTED,
  STATUS_SUBMITTED_TO_FEMA,
  STATUS_SUBAWARD_DECLINED,
  STATUS_SUBAWARD_OFFERED,
  PROGRAM_TYPE_PASSTHROUGH,
  STATUS_NOT_SELECTED,
  STATUS_CLOSEOUT_INITIATED,
  STATUS_PENDING_SUBMISSION,
  STATUS_RETURNED_TO_RECIPIENT,
} from 'app-ui-componentlibrary/dist/common/constants';
import {Link} from 'react-router-dom';
import {getGrantActions, formatDollarDecimals, showDollarAmountWithDollar,} from 'common/utils';
import REST from 'go/requests/rest';
import InitiateSubCloseoutReportModal from 'go/components/modules/application/InitiateSubCloseoutReportModal';
import CancelSubCloseoutReportModal from '../application/CancelSubCloseoutReportModal';
const ATTACHEMENT_PAGE_SIZE = 10;
const SUBGRANT_STATUSES = [
  STATUS_SUBMITTED_TO_FEMA,
  STATUS_INELIGIBLE,
  STATUS_NOT_SELECTED,
  STATUS_SUBAWARD_ACCEPTED,
  STATUS_SUBAWARD_DECLINED,
  STATUS_SUBAWARD_OFFERED,  
];

export class AttachedSubapplications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      pageSize: ATTACHEMENT_PAGE_SIZE,
      loadingSubOrgs: false,
      initiateSubCloseoutReportModalOpen: false,
      entityToInitiateForSubCloseout: {},
      cancelSubCloseoutReportModalOpen: false,
      entityToCancelForSubCloseout: {},
      subgrantAmendmentsInProgress: [],
    }; 
  }

  componentDidMount = () => {
    if (this.props.organizationId !== undefined) {
      this.getAllSuborganizations(this.props.organizationId);
    }
    if (this.props.includeAmendmentLinkData && this.props.amendments) {
      this.getAllAmendmentLinkData();
    } 
    if (_.includes(_.get(this.props.context, 'toggles.toggles'), 'enableProjectFormulationPostAward') && _.get(this.props.context, 'fundingOpportunityData.configData.foOverview.allowRecipientToAmendSubSection', false)) {  
        this.checkForPendingSubGrantAmendments(_.get(this.props.context, 'subGrantsForGrant.payload', []));
    }
  };  

  componentDidUpdate = (prevProps) => {
    if (
      this.props.includeAmendmentLinkData &&
      this.props.amendments &&
      this.props.amendments != prevProps.amendments
    ) {
      this.getAllAmendmentLinkData();
    }    
  };  
  
  UNSAFE_componentWillReceiveProps = ({organizationId}) => {
    if (
      !this.state.loadingSubOrgs &&
      organizationId !== undefined &&
      this.state.subOrgs === undefined
    ) {
      this.getAllSuborganizations(organizationId);
    }
  };

  doEntityAction(actionType, entity) {
    switch (actionType) {
      case 'viewSubApplication':
        // if status submittedTOFEMA & Ineligible. it is redirect to SGLP
        const win = _.includes(SUBGRANT_STATUSES, entity.status)
          ? window.open(`/subGrant/${entity.subGrantId}/subApplication`, '_blank')
          : window.open(`/subapplication/${entity.subapplicationId}/view`, '_blank');
        if (win != null) {
          win.focus();
        }
        break;
      case 'payment':
        // consider making default case if implementing other entities for creation from subgrant level
        REST.dynamicData
          .createEntityFromSubGrant(this.props.token, entity.subGrantId, 'payment')
          .then(REST.handler.handleResponse)
          .then((resJson) => {
            if (resJson) {
              const {entityId, entityType} = resJson;
              const win = window.open(`/${entityType}/${entityId}/edit`, '_blank');
              if (win != null) {
                win.focus();
              }
            }
          });
        break;
      case 'subAmendmentRecommendation':
        // consider making default case if implementing other entities for creation from subgrant level
        REST.dynamicData
          .createEntityFromSubGrant(
            this.props.token,
            entity.subGrantId,
            'subAmendmentRecommendation'
          )
          .then(REST.handler.handleResponse)
          .then((resJson) => {
            if (resJson) {
              const {entityId, entityType} = resJson;
              const win = window.open(`/${entityType}/${entityId}/edit`, '_blank');
              if (win != null) {
                win.focus();
              }
            }
          });
        break;
      case 'subCloseoutReport':
        this.setState({
          initiateSubCloseoutReportModalOpen: true,
          entityToInitiateForSubCloseout: entity,
        });
        break;
      case 'continueSubCloseoutReport':
        REST.dynamicData
          .getEntitiesBySubGrantIdAndEntityType(entity.subGrantId, 'subCloseoutReport')
          .then(REST.handler.handleResponse)
          .then((resJson) => {
            if (resJson) {
              const {entityId} = resJson[0];
              const win = window.open(`/subCloseoutReport/${entityId}/edit`, '_blank');
              if (win != null) {
                win.focus();
              }
            }
          });
        break;
      case 'cancelSubCloseoutReport':
        this.setState({
          cancelSubCloseoutReportModalOpen: true,
          entityToCancelForSubCloseout: entity,
        });
        break;
      default:
        null;
    }
  }

  getApplicationTypeLabel = (id) => {
    const appType = this.props.applicationTypes.APPLICATION_TYPE;
    const label = _.result(
      _.find(appType, function (obj) {
        return obj.id == id;
      }),
      'description'
    );
    return label;
  };
  setSubOrgsLoading = (value) => this.setState({loadingSubOrgs: value});

  getAllSuborganizations = (organizationId) => {
    this.setSubOrgsLoading(true);

    this.props.getAllExistingSubOrg(this.props.token, organizationId).then((res) => {
      this.setSubOrgsLoading(false);
      if (res.type === API_ORG_GET_ALL_SUBORGS_SUCCESS) {
        let newMap = new Map();
        _.forEach(res.payload, (org) => {
          newMap.set(org.organizationId, org.displayName);
        });
        this.setState({subOrgs: newMap});
      }
    });
  };

  getAllAmendmentLinkData = async () => {
    const {amendments, organizationId, programId} = this.props;
    const amendmentKeys = _.filter(Object.keys(amendments), (key) => key != 'loading');
    const amendmentIds = _.map(amendmentKeys, (a) => amendments[a].entityId);
    const amendmentLinks = await Promise.all(
      _.map(amendmentIds, (amendmentId) => {
        return REST.search
          .getAmendmentRecommendationLinksBySubAmendRecParent(
            amendmentId,
            organizationId,
            programId,
            null
          )
          .then(REST.handler.handleResponse);
      })
    );
    const amendmentLinkData = _.reduce(
      amendmentLinks,
      (data, current) => {
        data.total += current.total;
        data.items = [...data.items, ...current.items];
        return data;
      },
      {items: [], total: 0}
    );
    this.props.saveEntitySessionData('context.amendmentLinkData', amendmentLinkData);
  };  
    
  checkForPendingSubGrantAmendments = async (subGrantsForGrant) => {
    let pendingSubgrantAmendments = [];
    await Promise.all(_.map(subGrantsForGrant, async (entity, index) => {
      const entityToRender = entity;
      if (entity.subGrantId !== undefined) {
        let subGrantAmendmentsStatus = [];
        await REST.dynamicData
          .getBySubGrantIdAndEntityType(this.props.token, entity.subGrantId, 'subAmendmentRecommendation')
          .then(REST.handler.handleResponse)
          .then((data) => {
            _.map(data, (amendment) => {
              subGrantAmendmentsStatus.push(amendment.status);
            });
            const pendingSubgrantAmendmentsExist =
              _.includes(subGrantAmendmentsStatus, STATUS_PENDING_SUBMISSION) ||
              _.includes(subGrantAmendmentsStatus, STATUS_SUBMITTED_TO_FEMA) ||
              _.includes(subGrantAmendmentsStatus, STATUS_RETURNED_TO_RECIPIENT);
            if (pendingSubgrantAmendmentsExist) {
              pendingSubgrantAmendments.push(entity.entityId);
            }
          })
          .catch((err) => {
            console.error('error fetching subgrant amendments for subGrantId=' + entity.entityId);
            console.error(err);
          });
      }
    }));
    this.setState({ subgrantAmendmentsInProgress: pendingSubgrantAmendments });
  };


  handleOnCancelInitiateSubCloseoutReport = () => {
    this.setState({initiateSubCloseoutReportModalOpen: false});
  };

  handleOnCancelCancelSubCloseoutReport = () => {
    this.setState({cancelSubCloseoutReportModalOpen: false});
  };

  renderAttachSubapplication() {
    const {activePage, pageSize} = this.state;
    const initialData = {
      payload: {
        applicationTitle: '',
        applicationType: null,
        budget: {
          share: {
            fedShare: [''],
          },
        },
        subOrgId: null,
      },
    };

    const subApplicationsForPassthrough =
      _.get(this.props.context, 'grant.payload.programType') === PROGRAM_TYPE_PASSTHROUGH
        ? 'subApplicationsForGrant.payload'
        : 'applicationLinkData.items';
    const applicationLinkDataOrSubApplicationsForGrant = _.get(
      this.props.context,
      subApplicationsForPassthrough,
      _.get(this.props, 'subGrants', [])
    );

    const amendmentLinkData = _.get(this.props.context, 'amendmentLinkData.items', []);

    const combinedData = _.uniqBy(
      [...applicationLinkDataOrSubApplicationsForGrant, ...amendmentLinkData],
      'subGrantId'
    );

    const entities = this.props.includeAmendmentLinkData
      ? combinedData
      : applicationLinkDataOrSubApplicationsForGrant;

    const toggles = _.get(
      this.props,
      'toggles',
      _.get(this.props.context, 'context.toggles.toggles')
    );
    const permissions = _.get(
      this.props,
      'permissions',
      _.get(this.props.context, 'auth.permissions')
    );
    const subGrantEntities = this.props.subGrants;
    const subCloseoutReports = this.props.subCloseoutReports;
    const entitiesToRender = _.slice(
      entities,
      (activePage - 1) * pageSize,
      activePage * pageSize
    );   
    const entitiesEnabled = this.props.entitiesEnabled || ['viewSubApplication'];
    return (
      <Grid
        key={'amendmentsGrid'}
        doubling
        stackable
        reversed="mobile"
        padded="vertically"
        data-test="grid"
      >
        <Grid.Column style={{overflow:'auto'}}>
          <FemaGoTable summary={'Attached Subapplications'} type="static" columns={7}>
            <FemaGoTable.Header>
              <FemaGoTable.Row key="attachedSubapplicationsTableHeader">
                <FemaGoTable.HeaderCell>Subrecipient</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Subapplication ID</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Subapplication title</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Type</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Requested federal share</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body data-test="table-body">
              {_.map(entitiesToRender, (entity, index) => {
                let entityToRender = entity;
                if (subGrantEntities) {
                  let subGrantEntity = _.find(
                    subGrantEntities,
                    (subgrant) => subgrant.subGrantId === entity.subGrantId
                  );
                  if (subGrantEntity) {
                    let tempObj = {};
                    tempObj = produce(subGrantEntity, (draft) => {
                      if (
                        _.get(this.props.context, 'grant.payload.programType') !==
                        PROGRAM_TYPE_PASSTHROUGH
                      ) {
                        _.set(
                          draft,
                          'payload.applicationTitle',
                          _.get(entityToRender, 'payload.applicationTitle')
                        );
                        _.set(
                          draft,
                          'payload.applicationType',
                          _.get(entityToRender, 'payload.applicationType')
                        );
                      }
                      _.set(
                        draft,
                        'payload.budget',
                        _.get(entityToRender, 'payload.budget')
                      );
                    });
                    entityToRender = {...tempObj};
                  }
                }
                let subCloseoutReport = _.find(
                  subCloseoutReports,
                  (subCloseReport) => subGrantId === subCloseReport.subGrantId
                );
                let grantFoData = [];
                const foData = _.get(this.props.context, 'fundingOpportunityData', {});          
                grantFoData.push(foData);    
                let actions = [];
                actions = getGrantActions(
                  entityToRender,
                  toggles,
                  permissions,
                  entitiesEnabled,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  grantFoData,
                  null,
                  subCloseoutReport ? _.get(subCloseoutReport, '0.status') : undefined,
                  null,
                  null,                     
                  _.includes( this.state.subgrantAmendmentsInProgress, entityToRender.subGrantId),
                );
                const subapplicationId = _.get(
                  entity,
                  _.get(this.props.context, 'grant.payload.programType') ===
                    PROGRAM_TYPE_PASSTHROUGH
                    ? 'entityId'
                    : 'inner_hits.payload.subApplicationId',
                  ''
                );
                const subGrantId = entityToRender.subGrantId;
                const status = entityToRender.status;
                return (
                  entities && (
                    <FemaGoTable.Row
                      key={`${entityToRender.entityId}-row`}
                      data-test="table-row"
                    >
                      <FemaGoTable.TextCell>
                        {this.state.subOrgs
                          ? this.state.subOrgs.get(parseInt(entityToRender.subOrgId, 10))
                          : null}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        <Link
                          to={`/subgrant/${entityToRender.subGrantId}`}
                          target="_blank"
                        >
                          {_.get(entityToRender, 'subGrantId', '')}
                        </Link>
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(entityToRender, 'payload.applicationTitle', '')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {this.getApplicationTypeLabel(
                          _.get(entityToRender, 'payload.applicationType')
                        )}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell data-test="text-cell">
                        {_.get(
                          ASSOCIATED_ENTITY_STATUSES,
                          entityToRender.internalStatus
                            ? entityToRender.internalStatus
                            : entityToRender.status
                        )}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {showDollarAmountWithDollar(
                          _.sum(
                            _.map(
                              _.get(entityToRender, 'payload.budget.share.fedShare', ''),
                              (share) => +share
                            )
                          ).toString()
                        )}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        <Dropdown
                          data-test="dropdown"
                          selectOnNavigation={false}
                          selectOnBlur={false}
                          text={'Select action'}
                          name={`${entityToRender.entityId}-action-button`}
                          id={`${entityToRender.entityId}-action-button`}
                          onChange={(e, {name, value}) =>
                            this.doEntityAction(value, {
                              subapplicationId,
                              subGrantId,
                              status,
                            })
                          }
                          // upward={_.size(entitiesToRender) - index < 3} // Dropdown for last two will open up
                          options={actions}
                          value={''}
                        />
                      </FemaGoTable.TextCell>
                      <InitiateSubCloseoutReportModal
                        open={this.state.initiateSubCloseoutReportModalOpen}
                        entity={this.state.entityToInitiateForSubCloseout}
                        token={this.props.token}
                        entityType={'subCloseoutReport'}
                        onCancel={this.handleOnCancelInitiateSubCloseoutReport}
                      />
                      <CancelSubCloseoutReportModal
                        open={this.state.cancelSubCloseoutReportModalOpen}
                        entity={this.state.entityToCancelForSubCloseout}
                        token={this.props.token}
                        entityType={'subCloseoutReport'}
                        onCancel={this.handleOnCancelCancelSubCloseoutReport}
                      />
                    </FemaGoTable.Row>
                  )
                );
              })}
            </FemaGoTable.Body>
          </FemaGoTable>
          {entities && entities.length > ATTACHEMENT_PAGE_SIZE ? (
            <div className="pagination-wrapper pagination" data-test="paginate">
              <Pagination
                totalPages={Math.ceil(entities.length / ATTACHEMENT_PAGE_SIZE)}
                activePage={activePage}
                onPageChange={(e, data) => this.setState({activePage: data.activePage})}
              />
            </div>
          ) : (
            ''
          )}
        </Grid.Column>
      </Grid>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Segment data-test="segment">
          <Header
            as={'h4'}
            content={'Attached subapplications'}
            id={'Attachedsubapplications'}
          />
          {this.renderAttachSubapplication()}
        </Segment>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    applicationLinkData: state.applicationLinkData,
    applicationTypes: state.dynamicComponent
      ? state.dynamicComponent.context.loadRefApplicantType
      : [],
    programId: state.dynamicComponent ? state.dynamicComponent.data.programId : null,
    organizationId: state.dynamicComponent
      ? state.dynamicComponent.context.grant.organizationId
      : null,
    token: state.dynamicComponent ? state.auth.token : null,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getAllExistingSubOrg: async (token, orgId, programId) => {
    const action = ApiActions.organization.getAllSuborganizations(token, orgId);
    const response = dispatch(action);
    let res = await response;
    res.hasResults =
      res.type === API_ORG_GET_ALL_SUBORGS_SUCCESS && !_.isEmpty(res.payload);
    return res;
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(connectDynamic(AttachedSubapplications)));
